import { render, staticRenderFns } from "./noteTemplates.vue?vue&type=template&id=ca123024&"
import script from "./noteTemplates.vue?vue&type=script&lang=js&"
export * from "./noteTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports